import PageWithSidebar from "../PageWithSidebar";
import { useState, useEffect } from "react";
import CursoConcluidoImg from "../../assets/img/curso-concluido.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useCoursesApi } from "../../Hooks";
import RateCourse from "./RateCourse";
import DownloadCertificateButton from "../Shared/Buttons/DownloadCertificateButton";
import { region } from "../../Configs";
import { useTranslation } from "react-i18next";
import {getLocalizedRoutePath, ROUTE_KEYS} from "../../routes/definitions";

export default function CursoConcluido() {
  const [loading, setLoading] = useState(true);
  const [course, setCourse] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const coursesApi = useCoursesApi();
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const isCaRegion = region === "CA";
  
  useEffect(() => {
    setLoading(true);
    const loadData = async () => {
      await new Promise((r) => setTimeout(r, 300));
      const courseData = await coursesApi.fullCourse(id);
      if (!courseData.courseProgress?.completed) {
        navigate(getLocalizedRoutePath(ROUTE_KEYS.COURSE_DETAILS, language, { id: String(id) }));
      }
      else {
        setCourse(courseData);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <PageWithSidebar loading={loading} additionalClasses="flex flex-col">
      <div className="flex flex-row h-fit pb-5 border-b-gray-300 border-b-[3px] mb-5">
        <FontAwesomeIcon
          icon={faChevronLeft}
          className="text-2xl cursor-pointer self-center border border-black rounded-full py-3 px-4"
          onClick={() => navigate(getLocalizedRoutePath(ROUTE_KEYS.COURSE_DETAILS, language, { id: String(id) }))}
        />
        <div className="ml-5 flex flex-col">
          <p className="mt-auto text-xl font-bold my-auto">{t("backToCourse")}</p>
        </div>
      </div>
      <div className="mx-auto flex flex-col text-center gap-5">
        <img src={CursoConcluidoImg} className="mx-auto" alt="Curso Concluido" />
        <div className="flex flex-col md:flex-row gap-y-12">
          <div className="flex flex-col text-center md:text-left">
            {isCaRegion ? (
              <>
                <p className="text-2xl font-dosisbold mt-6">{t("courseCompletionCaLine1")}</p>
                <p className="text-xl font-inter text-playmove-darkgray mt-4">{t("courseCompletionCaLine2")}</p>
                <p className="text-xl font-inter text-playmove-darkgray mt-2">{t("courseCompletionCaLine3")}</p>
              </>
            ) : (
              <h1 className="text-2xl font-dosisbold mt-6">
                {t("congratulations")}
                <br />
                {t("youCompletedCourse")}
              </h1>
            )}
          </div>
          {(!isCaRegion && course?.rated) && <DownloadCertificateButton
            courseId={course?.id}
            courseTitle={course?.title}
            className="mx-auto md:mx-0 md:ml-auto mt-auto self-center w-[18rem]"
            rated={course?.rated}
          />}
        </div>
        <RateCourse course={course} onSuccess={() => {
          const tempCourse = {...course};
          tempCourse.rated = true;
          setCourse(tempCourse);
          }} />
      </div>
    </PageWithSidebar>
  );
}
